import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Card, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const StyledCard = styled(Card)(({ theme }) => ({
  width: '368px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
  height: 'fit-content',
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  height: '80px',
  padding: '16px',
}));

export const StyledCardContent = styled(CardContent)({
  padding: '0 !important',
});

export const StyledBox = styled(Box)(({ theme }) => ({
  height: '60px',
  padding: '16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const OrderConversionChartProvidersRatioScrollBox = styled(Box)(({ theme }) => ({
  height: '429px',
  minHeight: '429px',
  overflow: 'auto',
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const OrderConversionChartProvidersRatioHintBox = styled(Box)({
  height: '48px',
  padding: '16px',
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
});

export const OrderConversionChartProvidersRatioBarTitle = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: '2px',
});
